import React, { useContext, useEffect } from 'react'
import Navbar from './ui/Navbar'
import Map from './Map'
import CompleteProfilePopover from './Popovers/CompleteProfilePopover'
import UserProfile from './Popovers/UserProfile/UserProfile'
import FilterPopover from './Popovers/FilterPopover'
import TrialPopover from './Popovers/TrialPopover'
import BookmarkPopover from './Popovers/BookmarkPopover'
import PlaceDetailedPopover from './Popovers/PlaceDetailedPopover/PlaceDetailedPopover'
import RasterPopover from './Popovers/RasterPopover'
import MenuOverlay from './MenuOverlay'

import EnlargeModal from './ui/EnlargeModal'

import { useNavigate } from 'react-router-dom'
import { AppContext } from '../context'
import { API, getApiData, LOCATION_PARAMS } from '../api'
import { GeoJSONConverter } from '../map-layers-and-sources/GeoJSON'
import { FeatureCollection } from 'geojson'

const pako = require('pako')

const Explore: React.FC = () => {
  const subscriptionUrl = process.env.REACT_APP_SUBSCRIPTIONS_URL
  const navigate = useNavigate()
  const urlSearchParams = new URLSearchParams(window.location.search)
  const params = Object.fromEntries(urlSearchParams.entries())
  const { postLink } = params
  const { isAuthenticated, setLocations, placesSourceQuery } =
    useContext(AppContext)

  useEffect(() => {
    const updateParams = async () => {
      const data = await getApiData(
        process.env.REACT_APP_SOCIAL_URL +
          `api/socialPost/getSocialPostByPermalink/${postLink}`
      )

      const query = {
        lng:
          data.longitude !== null &&
          data.longitude !== undefined &&
          data.longitude !== ''
            ? data.longitude.toFixed(6)
            : data.longitude,
        lat:
          data.latitude !== null &&
          data.latitude !== undefined &&
          data.latitude !== ''
            ? data.latitude.toFixed(6)
            : data.latitude,
        zoom: 12,
        postId: data.id,
        postAuthorId: data.userId
      }

      const queryString = Object.keys(query)
        .map(key => `${key}=${query[key as keyof typeof query]}`)
        .join('&')
      navigate({ search: queryString })
    }
    if (postLink && isAuthenticated) {
      updateParams().then()
    }
  }, [postLink, isAuthenticated])

  useEffect(() => {
    const getLocations = async () => {
      try {
        //Get all locations
        const res = await API.get('/locations', {
          params: {
            ...LOCATION_PARAMS,
            facilities: placesSourceQuery,
            'compress-output': 'gzip'
          }
        })

        //Stringify response
        const base64Decoded = window.atob(res.data)

        // Convert the decoded string to a Uint8Array
        const arr = new Uint8Array(
          base64Decoded.split('').map(char => char.charCodeAt(0))
        )

        const data = JSON.parse(pako.inflate(arr, { to: 'string' }))?.locations

        //Format location data to GeoJSON
        const toGeoJson: FeatureCollection = GeoJSONConverter.parse(data)
        setLocations(toGeoJson)
      } catch (e) {
        console.error(`Error fetching locations! - ${e}`)
      }
    }

    isAuthenticated && getLocations()
  }, [isAuthenticated, placesSourceQuery])

  return (
    <>
      <Navbar />
      <Map />
      <UserProfile />
      <FilterPopover />
      <TrialPopover />
      <BookmarkPopover />
      <PlaceDetailedPopover />
      <RasterPopover />
      <MenuOverlay />
      <CompleteProfilePopover />

      <div className="mt-5 clearfix" style={{ display: 'none' }}>
        <div className="row">
          <div className="col-sm-4">
            <h3>Pointer info</h3>
            <pre id="info"></pre>
          </div>
          <div className="col-sm-4"></div>
          <div className="col-sm-4">
            <h4>Layers</h4>
            <div id="chart-options"></div>
            <a href={subscriptionUrl} className="btn btn-primary mt-3 mb-5">
              Buy digital charts
            </a>
          </div>
        </div>
      </div>

      {/* <!-- Image Modal --> */}
      <EnlargeModal />

      <span
        style={{ display: 'none' }}
        className="material-icons-outlined material-symbols-outlined"
      >
        sync
      </span>
    </>
  )
}
export default Explore
